import TicketOfferListContainer from '../../../../Componant/Application/Ecommerce/master/TicketOfferListContainer'

const AllTicketOfferList = () => {
  return (
    <div className='page-body'>
      <TicketOfferListContainer />
    </div>
  )
}

export default AllTicketOfferList